import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { getAllProducts, getCategories } from '../../Services/ShopServices';

const useShopList = () => {

    const [filterRange, setFilterRange] = useState(50)
    const [allProducts, setAllProducts] = useState([])
    const [allCategories, setAllCategories] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [links, setLinks] = useState([])
    const [currentPage, setCurrentPage] = useState(1)
    const [totalProducts, setTotalProducts] = useState("")
    const [showingProducts, setShowingProducts] = useState("")

    const handlecCurrentPage = (page) => {
        setCurrentPage(page)
    }

    const [category, setCategory] = useState("")


    const handleRangeChange = (e) => {
        setFilterRange(e.target.value);
    };

    const handleGetAllProducts = async () => {
        setIsLoading(true)
        let response = await getAllProducts(category, currentPage)
        if (response.statusCode === 200) {
            setAllProducts(response?.response?.data?.data)
            setLinks(response?.response?.data?.links)
            setTotalProducts(response?.response?.data?.total)
            setShowingProducts(response?.response?.data?.to)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    const handleGetAllCategories = async () => {
        setIsLoading(true)
        let response = await getCategories()
        if (response.statusCode === 200) {
            setAllCategories(response?.response?.data)
            setIsLoading(false)
        } else if (response.statusCode === 401) {
            toast?.error(response?.errors)
            setIsLoading(false)
        } else {
            for (const [key, value] of Object.entries(response?.errors)) {
                toast?.error(value)
            }
            setIsLoading(false)
        }
        setIsLoading(false)
    }

    useEffect(() => {
        handleGetAllProducts()
    }, [category])


    useEffect(() => {
        handleGetAllCategories()
    }, [])

    useEffect(() => {
        handleGetAllProducts()
    }, [currentPage])

    return [
        filterRange,
        allProducts,
        isLoading,
        links,
        currentPage,
        totalProducts,
        showingProducts,
        handlecCurrentPage,
        handleRangeChange,
        allCategories,
        category,
        setCategory
    ]
}

export default useShopList